export enum DIRECTORY_PICKER {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=241948220
     */
    PICK_DIRECTORY = 'DIRECTORY_PICKER.PICK_DIRECTORY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=258933443
     */
    DIRECTORIES_FROM_YOUR_SITE = 'DIRECTORY_PICKER.DIRECTORIES_FROM_YOUR_SITE',
}
